import { Component, Input } from '@angular/core';

export type iconWeight = 'regular' | 'solid' | 'light' | 'brands' | 'thin';
export type iconSize =
  | 'xs'
  | 'sm'
  | 'lg'
  | 'xl'
  | '2xl'
  | '1x'
  | '2x'
  | '3x'
  | '4x'
  | '5x'
  | '6x'
  | '7x'
  | '8x'
  | '9x'
  | '10x';

export const ICON_MAP = {
  language: 'language',
  add: 'add',
  favorite: 'heart',
  login: 'arrow-right-to-bracket',
  logout: 'arrow-right-from-bracket',
  menu: 'bars',
  close: 'xmark-large',
  cancel: 'xmark',
  xmark: 'xmark',
  angleRight: 'angle-right',
  angleDoubleRight: 'angles-right',
  angleLeft: 'angle-left',
  angleDown: 'angle-down',
  angleUp: 'angle-up',
  arrowRight: 'arrow-right',
  arrowLeft: 'arrow-left',
  arrowDown: 'arrow-down',
  arrowUp: 'arrow-up',
  next: 'angle-right',
  prev: 'angle-left',
  angleClosed: 'angle-up',
  edit: 'pen-to-square',
  search: 'magnifying-glass',
  filter: 'filter',
  share: 'share-nodes',
  delete: 'trash',
  password: 'key',
  list: 'list-ul',
  copy: 'copy',
  results: 'grid-2',
  zip: 'file-zip',
  calendar: 'calendar',
  error: 'exclamation-triangle',
  admin: 'user-gear',
  circleCheck: 'circle-check',
  check: 'check',
  circleQuestion: 'circle-question',
  circleInfo: 'circle-info',
  youtube: 'youtube',
  linkedin: 'linkedin',
  instagram: 'instagram',
  facebook: 'facebook',
  rotate: 'rotate',
  spinner: 'spinner',
  arrowDownWideShort: 'arrow-down-wide-short',
  cloneInstance: 'clone',
  resultCard: 'clipboard',
  resultArticle: 'newspaper',
  horizontalEllipsis: 'ellipsis',
  handHoldingHeart: 'hands-holding-heart',
  bullsEyeArrow: 'bullseye-arrow',
  profileCard: 'address-card',
  commentQuestion: 'comments-question',
  calendarStar: 'calendar-star',
  display: 'display',
  newTab: 'up-right-from-square',
  refresh: 'arrows-retweet',
  community: 'users',
  platform: 'laptop-mobile',
  purpose: 'screen-users',
  donation: 'hand-holding-heart',
  info: 'circle-info',
} as const;

export type usableIcons = keyof typeof ICON_MAP;

@Component({
  selector: 'vee-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  standalone: false,
})
export class IconComponent {
  @Input() weight: iconWeight = 'regular';
  @Input() icon: usableIcons = 'add';
  @Input() size?: iconSize;
  @Input() spin: boolean = false;

  public get iconClasses(): string {
    const faIconName = ICON_MAP[this.icon];
    const weight = this.weight === 'brands' ? 'fab' : `fa-${this.weight}`;
    const classes = [weight, `fa-${faIconName}`];

    if (this.size) {
      classes.push(`fa-${this.size}`);
    }

    if (this.spin) {
      classes.push('fa-spin');
    }

    return classes.join(' ');
  }
}
